module.exports = __webpack_public_path__ + "static/media/image-6.40132f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-6.png
// module id = 2252
// module chunks = 0